import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Monogram } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center spotlight px-4 pt-28 pb-16">
      <div className="bg-cream border border-chocolate/10 max-w-lg w-full p-10 sm:p-14 text-center">
        <div className="flex justify-center mb-8"><Monogram size={52} /></div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-golddark mb-4">Checkout cancelled</p>
        <h1 className="font-serif text-3xl font-light text-chocolate">No charge was made.</h1>
        <p className="text-sm text-chocolate/60 mt-4 leading-relaxed">
          Your piece is still waiting in The Collection whenever you're ready — or send us an enquiry and we'll arrange everything personally.
        </p>
        <Link to="/collection" data-testid="payment-cancel-back"
          className="group inline-flex items-center gap-2 mt-8 bg-chocolate text-cream px-8 py-4 font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-espresso transition-colors">
          <ArrowLeft size={14} className="group-hover:-translate-x-1 transition-transform" /> Back to The Collection
        </Link>
      </div>
    </div>
  );
}
